<template>
  <v-dialog v-model="show" fullscreen>
    <v-card flat>
      <v-container fluid style="padding-bottom:100px">

        <div class="dialog-toolbar">
          <v-col cols="9" md="11">
            <h3>{{ dialogTitle }}</h3>
          </v-col>
          <v-col cols="1" md="1" class="pull-right-on-desktop">
            <v-icon @click="$emit('close-dialog')" style="transform: translateX(-15px)">close</v-icon>
          </v-col>
        </div>

        <div style="height: 70px;"></div>
        <v-row>
          <v-col cols="12" md="6" offset-md="3">
            <v-row style="margin:0">
              <v-col cols="12">
                <v-textarea
                  v-model="currentItem.description"
                  @input="$v.currentItem.description.$touch()"
                  :error="$v.currentItem.description.$error"
                  :error-messages="descriptionErrors"
                  label="Descripción"
                  auto-grow rows="1"
                  style="margin-top:0;padding-top:0"
                  autofocus
                ></v-textarea>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="currentItem.cant"
                  @input="$v.currentItem.cant.$touch()"
                  :error="$v.currentItem.cant.$error"
                  :error-messages="cantErrors"
                  label="Cantidad"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="currentItem.amount"
                  @input="$v.currentItem.amount.$touch()"
                  :error="$v.currentItem.amount.$error"
                  :error-messages="amountErrors"
                  label="Precio unitario"
                  type="number"
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="display:flex;justify-content:center;">
                <v-btn v-if="canDeleteItem" color="error" @click="deleteItem" style="margin-right: 12px">ELIMINAR</v-btn>
                <v-btn color="secondary" :disabled="saveButtonDisabled" @click="addItem">{{ saveButtonTitle }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-container>

    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    show: Boolean,
    item: {
      type: Object,
      default: () => {
        return {
          description: null,
          cant: null,
          amount: null
        }
      }
    },
    type: String
  },
  data () {
    return {
      currentItem: {
        description: null,
        cant: null,
        amount: null
      }
    }
  },
  created () {
    this.currentItem = { ...this.item }
  },
  validations () {
    const validations = {
      currentItem: {
        description: { required },
        cant: { required },
        amount: { required }
      }
    }
    return validations
  },
  computed: {
    canDeleteItem: function () {
      if (this.item.id) {
        return true
      } else if (!this.item.id) {
        return false
      }
      return null
    },
    saveButtonTitle: function () {
      if (this.item.id) {
        return 'Guardar'
      } else if (!this.item.id) {
        return 'Agregar item'
      }
      return null
    },
    saveButtonDisabled: function () {
      if (!this.currentItem.description || !this.currentItem.cant || !this.currentItem.amount) return true
      return false
    },
    dialogTitle: function () {
      if (this.item.id) {
        if (this.type === 'manpower') {
          return 'Editar item mano de obra'
        } else if (this.type === 'supplies') {
          return 'Editar item insumos'
        }
      } else if (!this.item.id) {
        if (this.type === 'manpower') {
          return 'Nuevo item mano de obra'
        } else if (this.type === 'supplies') {
          return 'Nuevo item insumos'
        }
      }
      return null
    },
    descriptionErrors: function () {
      const errors = []
      if (!this.$v.currentItem.description.$error) return errors
      !this.$v.currentItem.description.required && errors.push('Este campo es requerido')
      return errors
    },
    cantErrors: function () {
      const errors = []
      if (!this.$v.currentItem.cant.$error) return errors
      !this.$v.currentItem.cant.required && errors.push('Este campo es requerido')
      return errors
    },
    amountErrors: function () {
      const errors = []
      if (!this.$v.currentItem.amount.$error) return errors
      !this.$v.currentItem.amount.required && errors.push('Este campo es requerido')
      return errors
    }
  },
  methods: {
    addItem () {
      this.$v.currentItem.$touch()
      if (!this.$v.currentItem.$error) {
        this.$emit('save-item', this.currentItem)
        this.$emit('close-dialog')
      }
    },
    deleteItem () {
      this.$emit('delete-item')
      this.$emit('close-dialog')
    },
    formatDate (date) {
      const _date = new Date()
      const today = moment(_date).format('YYYY-MM-DD')
      if (date === today) {
        return 'Hoy'
      } else {
        return moment(date, 'YYYY-MM-DD').format('dddd DD MMMM, YYYY')
      }
    }
  }
}
</script>
<style scoped>
  @media(min-width:960px){
    .pull-right-on-desktop {
      display: flex;
      justify-content: flex-end;
    }
  }
  .bottom-bar {
    position: fixed;
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 88px;
    display: flex;
    justify-content: flex-end;
  }
  .pb24 {
    padding-bottom: 84px;
  }
  .pb0 {
    padding-bottom: 0;
  }
  .pt0 {
    padding-top: 0;
  }
  .p0 {
    padding: 0;
  }
  .m0 {
    margin: 0;
  }
  .date {
    text-transform: capitalize;
    text-align: left;
  }
  .status-name-cont {
    height: 30px;
    background: #c8272a;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 12px;
    text-transform: capitalize;
  }
</style>
